import React, { useState } from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import convert from 'htmr'

type Props = {
  question: string
  answer: string
}

const transforms = {
  transform: {
    p: function P(props) {
      return <p className="mb-16">{props.children}</p>
    },
    ul: function Ul(props) {
      return <ul className="">{props.children}</ul>
    },
    li: function Li(props) {
      return <li className="">{props.children}</li>
    },
    strong: function Strong(props) {
      return <strong className="font-bold">{props.children}</strong>
    },
    h1: function H1(props) {
      // semantically make it h2 to prevent multiple h1s on the page
      return <h2 className="mb-4 mt-16 font-demibold">{props.children}</h2>
    },
    h2: function H2(props) {
      return <h2 className="mb-4 mt-16 font-demibold">{props.children}</h2>
    },
    h3: function H3(props) {
      return <h3 className="mb-4 mt-16 font-demibold">{props.children}</h3>
    },
    h4: function H4(props) {
      return <h2 className="mb-4 mt-16 font-demibold">{props.children}</h2>
    },
  },
}

const FaqItem = ({ answer, question }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleToggle = (title: string) => {
    setIsOpen(!isOpen)
    pushToDataLayer({
      event: 'click_event',
      click_type: 'accordion',
      click_text: title.toLowerCase(),
      action: isOpen ? 'close' : 'open',
      location: 'frequently asked questions',
    })
  }

  return (
    <div className="mb-8 max-w-[620px] cursor-pointer rounded-8 bg-BgContent py-20 pl-16 pr-12 shadow-greyShadow">
      <div
        className="flex items-center justify-between gap-x-[20px] text-14 font-semiregular leading-19"
        onClick={() => handleToggle(question)}
      >
        {question}{' '}
        <FeatureImage
          image={lpImages.chevronIcon}
          className={isOpen ? 'rotate-180' : 'rotate-0'}
        />{' '}
      </div>
      {isOpen && (
        <div className="mt-[6px] pr-20 text-14 font-semiregular leading-19 text-text-grey">
          {convert(answer, transforms)}
        </div>
      )}
    </div>
  )
}

export default FaqItem
